import request from "@/utils/request";

// 充电桩

// 检查充电桩是否可用
export const checkDevice = params => {
	return request({
		url: "/device/availability",
		method: "GET",
		params,
	});
};

// 添加充电桩
export const registerDevice = data => {
	return request({
		url: "/device/registration",
		method: "POST",
		data,
	});
};

// 查询充电桩
export const getDevice = params => {
	return request({
		url: "/device",
		method: "GET",
		params,
	});
};

// 保存充电桩
export const setDevice = data => {
	return request({
		url: "/device",
		method: "POST",
		data,
	});
};

// 删除充电桩
export const removeDevice = params => {
	return request({
		url: "/device",
		method: "DELETE",
		params,
	});
};

// 配置充电桩
export const setDeviceSetting = data => {
	return request({
		url: "/device/setting",
		method: "POST",
		data,
	});
};

// 配置站内充电桩
export const setDeviceSettingBySite = data => {
	return request({
		url: "/device/setting/site",
		method: "POST",
		data,
	});
};

// 查询配置结果
export const getDeviceSettingStatus = params => {
	return request({
		url: "/device/setting/status",
		method: "GET",
		params,
	});
};

// 启动充电
export const startChargingOnDevice = data => {
	return request({
		url: "/device/charge/start",
		method: "POST",
		data,
	});
};

// 结束充电
export const stopChargingOnDevice = data => {
	return request({
		url: "/device/charge/stop",
		method: "POST",
		data,
	});
};

// 下载设备文件
export const queryDeviceDataFile = data => {
	return request({
		url: "/deviceData/query",
		method: "POST",
		data,
	});
};

// 读取文件内容
export const readDeviceTaskFile = params => {
	return request({
		url: "/deviceTask/read",
		method: "GET",
		params,
	});
};

// 下发文件内容
export const setDeviceFile = data => {
	return request({
		url: "/device/File",
		method: "POST",
		data,
	});
};

// 下发文件结果
export const getDeviceFileStatus = params => {
	return request({
		url: "/deviceTask/status",
		method: "GET",
		params,
	});
};

// 修改充电口状态
export const setDevicePortStatus = data => {
	return request({
		url: "/deviceportstatus",
		method: "POST",
		data,
	});
};
//设备功能
export const getDeviceFeature = params => {
	return request({
		url: "/device/feature",
		method: "GET",
		params,
	});
};

//查询设备近7天的事件
export const getDeviceEventRecord = params => {
	return request({
		url: "/device/event/record",
		method: "GET",
		params,
	});
};
//查询设备事件
export const getdeviceTask = params => {
	return request({
		url: "/deviceTask",
		method: "GET",
		params,
	});
};
//重试设备任务
export const retrydeviceTask = params => {
	return request({
		url: "/deviceTask/retry",
		method: "GET",
		params,
	});
};
//上传设备日志
export const queryDeviceLogFile = data => {
	return request({
		url: "/deviceLog/query",
		method: "POST",
		data,
	});
};
